import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { onLogout, selectUsers } from "../state/reducers/userSlice";
import { connect, useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { clearState } from "../state/store";
import { Modal } from "react-responsive-modal";
import { Link } from "react-router-dom";
import ssrsService from "../services/ssrs-service";
import userService from "../services/users-service";
import facilityService from "../services/facility-service";
import { updateFacility, updateAccess } from "../state/reducers/userSlice";
import { withRouter } from "react-router-dom";
import cogoToast from "cogo-toast";
import { useOktaAuth } from "@okta/okta-react";
import { canAccessRoute } from "../utils/routeAccess";
import helpIcon from "../assets/img/help.png";

const CipHeader = ({ history }) => {
  const dispatch = useDispatch();
  const { user } = useSelector(selectUsers);
  const { oktaAuth } = useOktaAuth();
  const [open, setOpen] = useState(false);
  const onCloseModal = () => setOpen(false);
  const [edituserOpen, setEditUserOpen] = useState(false);
  const onCloseUserModal = () => setEditUserOpen(false);
  const { register, handleSubmit, errors } = useForm({});
  const [facilityList, setfacilityList] = useState();
  const [userFac, setUserFac] = useState();
  const [userFacName, setUserFacName] = useState();

  const logoutFromOkta = async () => {
    // Will redirect to Okta to end the session then redirect back to the configured `postLogoutRedirectUri`
    try {
      await oktaAuth.signOut();
      clearState();
      dispatch(onLogout());
    } catch (e) {
      const { hide } = cogoToast.error("Error logging out.", {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
    }
  };
  const facSubmit = async (data) => {
    try {
      let new_facList = {
        facility: data.chngefacility,
        userId: user.userId,
        currentUser: true,
      };
      let resp = await userService.updateUser(new_facList);
      if (resp) {
        const newAccess = await facilityService.getAccessForFacilities(data.chngefacility);
        dispatch(updateFacility({ facility: data.chngefacility }));
        dispatch(updateAccess(newAccess));
        setAccess(newAccess);
        setEditUserOpen(false);
        const { hide } = cogoToast.success("Facility Changed Successfully!!", {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
        if (canAccessRoute(window.location.pathname, user, newAccess)) {
          window.location.reload();
        } else {
          window.location.href = '/dashboard';
        }
      }
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error changing facility. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const [types, setTypes] = useState([]);
  const getSSRSTypes = async () => {
    try {
      let resp = await ssrsService.getSsrsTypes();
      setTypes(resp);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting types. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const [access, setAccess] = useState({});
  const isFLStockEnabled = access?.fl_stock === "T";
  const getAccessForFacility = async () => {
    try {
      let resp = await facilityService.getAccessForFacilities(user?.facility);
      setAccess(resp);
      dispatch(updateAccess(resp));
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  useEffect(() => {
    const getFacility = async () => {
      if (user?.token) {
        if (user.userType === "EXTERNAL") {
          try {
            let resp = await facilityService.getFacilities();
            if (resp) {
              setfacilityList(resp);
              setUserFac(user?.facility);
            }
            if (user.facility && user.userRole !== "PORTAL_ADMIN") {
              let facDetails = await facilityService.getFacilityNameById(
                user.facility
              );
              if (facDetails) {
                setUserFacName(facDetails.name);
              }
            }
          } catch (e) { }
        } else if (
          user.userType === "INTERNAL" &&
          user.userRole !== "PORTAL_ADMIN"
        ) {
          setUserFacName(user.department.replace("_", " "));
        }
      } else {
        await history.push("/");
      }
    };
    getFacility();
    getSSRSTypes();
    if (user?.userType === "EXTERNAL") {
      getAccessForFacility();
    }
  }, [user, history]);
  return (
    <div className="">
      <div className="w-full h-20 md:h-16 pt-5 md:pt-3 p-4 bg-header_bg">
        <div className="flex w-full clearfix clear-both">
          <div className="w-1/2 cursor-pointer">
            <img src="/img/CSP_logo2.png" className="mt-1 w-64" alt="logo" />
          </div>
          <div className="w-1/2 mt-0.5 cursor-pointer">
            <div className="flex justify-end md:mr-20">
              <div>
                <div className="dropdown inline-block relative">
                  <button className="bg-gray-300 text-gray-700 font-semibold px-4 rounded inline-flex  focus:outline-none ">
                    <span className="mr-1 flex text-left">
                      <img
                        src="/img/profile2.svg"
                        alt=""
                        className="w-8 ml-2 mr-2"
                      />
                      <div className="text-white capitalize">
                        <span className="block text-sm font-semibold">
                          {user?.firstName}
                        </span>
                        <span className="block text-xs capitalize">
                          {user?.userRole?.replace(/_/g, " ")?.toLowerCase()}
                        </span>
                        <span className="text-white text-xs block">
                          {userFacName}
                        </span>
                      </div>
                    </span>
                    <svg
                      className="fill-current h-4 w-4 text-white mt-2"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />{" "}
                    </svg>
                  </button>
                  <ul className="dropdown-menu absolute hidden text-gray-700 pt-1 rounded-sm bg-white z-50 shadow-subheader width-3/4 left-16 top-12">
                    <li className="hover:bg-gray-400">
                      <Link
                        className="rounded-t bg-gray-200 hover:bg-gray-400 hover:text-red py-2 px-4 block whitespace-no-wrap"
                        to={`/edit-user/${user?.userId}`}
                      >
                        Edit Profile
                      </Link>
                    </li>
                    {user?.userType === "EXTERNAL" ? (
                      <>
                        <li className="">
                          <button
                            className="bg-gray-200 hover:bg-gray-400 py-2 px-4 block whitespace-no-wrap"
                            onClick={() => {
                              setEditUserOpen(true);
                            }}
                          >
                            Change Facility
                          </button>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                  </ul>
                </div>
              </div>
              <div>
                <img
                  src="/img/logout.svg"
                  onClick={() => {
                    logoutFromOkta();
                  }}
                  alt=""
                  className="w-5 mt-2 ml-6"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex w-full clearfix clear-both bg-white shadow-subheader">
        <div className="w-5/6  mx-auto ">
          <div className="w-full float-left inline-block">
            <ul className="mainmenu relative text-menu_txt ">
              <li className="inline-block relative leading-8 mr-4">
                <Link
                  to="/"
                  className={`block py-3 px-8 rounded-lg rounded-b-none cursor-pointer hover:bg-bodybgrnd menuLi customMargin hover:text-menuHvrColor ${window.location.pathname === "/dashboard"
                      ? "bg-bodybgrnd menuHvrBorder"
                      : ""
                    }`}
                >
                  <span
                    className={`inline-block float-left mr-3 ${window.location.pathname === "/dashboard"
                        ? "homeActiveImg"
                        : "homeImg"
                      }`}
                  ></span>
                  <span
                    className={`inline-block text-sm ${window.location.pathname === "/dashboard"
                        ? "text-menuHvrColor font-semibold"
                        : ""
                      }`}
                  >
                    HOME
                  </span>
                </Link>
              </li>
             {user.userRole !== "EMAR_USER"&& user.userRole !== "PROVIDER" && <li className="inline-block relative leading-8 mr-4">
                <button
                  className={`block py-3 px-8 rounded-lg rounded-b-none cursor-pointer hover:bg-bodybgrnd customMargin appmenuLi hover:text-menuHvrColor ${window.location.pathname === "/returns" ||
                      window.location.pathname === "/shipingScan" ||
                      window.location.pathname === "/stockOrder" ||
                      window.location.pathname === "/flStockOrderForm" ||
                      window.location.pathname === "/FLStockOrder" ||
                      window.location.pathname === "/approvalQue" ||
                      window.location.pathname === "/stocks" ||
                      window.location.pathname === "/invoice" ||
                      window.location.pathname === "/delivery" ||
                      window.location.pathname === "/patientDetails" ||
                      window.location.pathname.startsWith("/epcis-viewer") ||
                      window.location.pathname === "/clarifications"
                      ? "bg-bodybgrnd menuHvrBorder"
                      : ""
                    }`}
                >
                  <span
                    className={`inline-block float-left mr-3 w-6 h-8 ${window.location.pathname === "/returns" ||
                        window.location.pathname === "/shipingScan" ||
                        window.location.pathname === "/stockOrder" ||
                        window.location.pathname === "/flStockOrderForm" ||
                        window.location.pathname === "/FLStockOrder" ||
                        window.location.pathname === "/approvalQue" ||
                        window.location.pathname === "/stocks" ||
                        window.location.pathname === "/invoice" ||
                        window.location.pathname === "/delivery" ||
                        window.location.pathname === "/patientDetails" ||
                        window.location.pathname.startsWith("/epcis-viewer") ||
                        window.location.pathname === "/clarifications"
                        ? "appActiveImg"
                        : "appImg"
                      }`}
                  ></span>
                  <span
                    className={`inline-block text-sm ${window.location.pathname === "/returns" ||
                        window.location.pathname === "/shipingScan" ||
                        window.location.pathname === "/stockOrder" ||
                        window.location.pathname === "/flStockOrderForm" ||
                        window.location.pathname === "/FLStockOrder" ||
                        window.location.pathname === "/approvalQue" ||
                        window.location.pathname === "/stocks" ||
                        window.location.pathname === "/invoice" ||
                        window.location.pathname === "/delivery" ||
                        window.location.pathname === "/patientDetails" ||
                        window.location.pathname.startsWith("/epcis-viewer") ||
                        window.location.pathname === "/clarifications"
                        ? "text-menuHvrColor font-semibold"
                        : ""
                      }`}
                  >
                    APPLICATIONS
                  </span>
                </button>
                <>
                  {user?.userType === "EXTERNAL" ? (
                    <ul className="submenu bg-bodybgrnd absolute hidden z-50 text-white w-full">
                      <li className="inline-block relative w-full">
                        <Link
                          to="/returns"
                          className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full returnmenuLi hover:text-menuHvrColor ${window.location.pathname === "/returns"
                              ? "bg-menu_active"
                              : ""
                            }`}
                        >
                          <span
                            className={`inline-block float-left mr-3 ${window.location.pathname === "/returns"
                                ? "returnActiveImg"
                                : "returnImg"
                              }`}
                          >
                            {" "}
                          </span>
                          <span
                            className={`inline-block text-sm ${window.location.pathname === "/returns"
                                ? "text-menuHvrColor font-semibold"
                                : "menuTxt"
                              }`}
                          >
                            RETURNS
                          </span>
                        </Link>
                      </li>
                      {user.userRole === "FACILITY_USER" ||
                        user.userRole === "FACILITY_ADMIN" ? (
                        <>
                          {isFLStockEnabled && (
                            <li className="inline-block relative w-full eom">
                              <span className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full patientsmenuLi hover:text-menuHvrColor ${window.location.pathname === "/FLStockOrder" || window.location.pathname === "/approvalQue" || window.location.pathname.startsWith("/epcis-viewer") ? "bg-menu_active" : ""}`}>
                                <span className={`inline-block float-left mr-3 ${window.location.pathname === "/FLStockOrder" || window.location.pathname === "/approvalQue" || window.location.pathname.startsWith("/epcis-viewer") ? "stockOrderActiveImg" : "stockOrderImg"}`}></span>
                                <span className={`inline-block w-1/2 text-sm ${window.location.pathname === "/FLStockOrder" || window.location.pathname === "/approvalQue" || window.location.pathname.startsWith("/epcis-viewer") ? "text-menuHvrColor font-semibold" : "menuTxt"}`}>FL STOCKS</span>
                              </span>
                              <ul className="submenu2 bg-bodybgrnd absolute hidden z-50 text-white w-full left-full top-0">
                                <li className="inline-block relative w-full">
                                  <Link to="/FLStockOrder" className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full stockOrdermenuLi hover:text-menuHvrColor ${window.location.pathname === "/FLStockOrder" ? "bg-menu_active" : ""}`}>
                                    <span className={`inline-block float-left mr-3 ${window.location.pathname === "/FLStockOrder" ? "stockOrderActiveImg" : "stockOrderImg"}`}></span>
                                    <span className={`inline-block text-sm ${window.location.pathname === "/FLStockOrder" ? "text-menuHvrColor font-semibold" : "menuTxt"}`}>FL STOCK ORDERS</span>
                                  </Link>
                                </li>
                                {user.userRole === "FACILITY_ADMIN" && (
                                  <li className="inline-block relative w-full">
                                    <Link to="/approvalQue" className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full stockOrdermenuLi hover:text-menuHvrColor ${window.location.pathname === "/approvalQue" ? "bg-menu_active" : ""}`}>
                                      <span className={`inline-block float-left mr-3 ${window.location.pathname === "/approvalQue" ? "stockOrderActiveImg" : "stockOrderImg"}`}></span>
                                      <span className={`inline-block text-sm ${window.location.pathname === "/approvalQue" ? "text-menuHvrColor font-semibold" : "menuTxt"}`}>FL STOCK APPROVAL</span>
                                    </Link>
                                  </li>
                                )}
                                <li className="inline-block relative w-full">
                                  <Link to="/epcis-viewer" className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full epcisListmenuLi hover:text-menuHvrColor ${window.location.pathname.startsWith("/epcis-viewer") ? "bg-menu_active" : ""}`}>
                                    <span className={`inline-block float-left mr-3 ${window.location.pathname.startsWith("/epcis-viewer") ? "epcisActiveImg" : "epcisImg"}`}></span>
                                    <span className={`inline-block text-sm ${window.location.pathname.startsWith("/epcis-viewer") ? "text-menuHvrColor font-semibold" : "menuTxt"}`}>EPCIS FILES</span>
                                  </Link>
                                </li>
                              </ul>
                            </li>
                          )}
                          {!isFLStockEnabled && (
                            <li className="inline-block relative w-full">
                              <Link to="/stockOrder" className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full stockOrdermenuLi hover:text-menuHvrColor ${window.location.pathname === "/stockOrder" ? "bg-menu_active" : ""}`}>
                                <span className={`inline-block float-left mr-3 ${window.location.pathname === "/stockOrder" ? "stockOrderActiveImg" : "stockOrderImg"}`}></span>
                                <span className={`inline-block text-sm ${window.location.pathname === "/stockOrder" ? "text-menuHvrColor font-semibold" : "menuTxt"}`}>STOCK ORDERS</span>
                              </Link>
                            </li>
                          )}
                          {access?.delivery_recon === "T" && (
                            <li className="inline-block relative w-full">
                              <Link
                                to="/delivery"
                                className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full deliveryForm stockOrdermenuLi hover:text-menuHvrColor ${window.location.pathname === "/delivery"
                                    ? "bg-menu_active"
                                    : ""
                                  }`}
                              >
                                <span
                                  className={`inline-block float-left mr-3 ${window.location.pathname === "/delivery"
                                      ? "deliveryActiveImg"
                                      : "deliveryImg"
                                    }`}
                                ></span>
                                <span
                                  className={`inline-block text-sm ${window.location.pathname === "/delivery"
                                      ? "text-menuHvrColor font-semibold"
                                      : "menuTxt"
                                    }`}
                                >
                                  DELIVERY RECONCILIATION
                                </span>
                              </Link>
                            </li>
                          )}
                          <li className="inline-block relative w-full eom">
                            <span
                              className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full patientsmenuLi hover:text-menuHvrColor ${window.location.pathname === "/patient"
                                  ? "bg-menu_active"
                                  : ""
                                }`}
                            >
                              <span
                                className={`inline-block float-left mr-3 ${window.location.pathname === "/patient"
                                    ? "patientsActiveImg"
                                    : "patientsImg"
                                  }`}
                              ></span>
                              <span
                                className={`inline-block w-1/2 text-sm ${window.location.pathname === "/patient"
                                    ? "text-menuHvrColor font-semibold"
                                    : "menuTxt"
                                  }`}
                              >
                                PATIENTS
                              </span>
                            </span>
                            <ul className="submenu2 bg-bodybgrnd absolute hidden z-50 text-white w-full left-full top-0">
                              <li className="inline-block relative w-full">
                                <Link
                                  to="/patientDetails"
                                  className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full patientMedicationListmenuLi hover:text-menuHvrColor ${window.location.pathname ===
                                      "/patientDetails"
                                      ? "bg-menu_active"
                                      : ""
                                    }`}
                                >
                                  <span
                                    className={`inline-block float-left mr-3 ${window.location.pathname ===
                                        "/patientDetails"
                                        ? "patientMedicationActiveImg"
                                        : "patientMedicationImg"
                                      }`}
                                  ></span>
                                  <span
                                    className={`inline-block text-sm ${window.location.pathname ===
                                        "/patientDetails"
                                        ? "text-menuHvrColor font-semibold"
                                        : "menuTxt"
                                      }`}
                                  >
                                    PATIENT MEDICATIONS
                                  </span>
                                </Link>
                              </li>
                              <li className="inline-block relative w-full">
                                <Link
                                  to="/patients"
                                  className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full patientListListmenuLi hover:text-menuHvrColor ${window.location.pathname === "/patients"
                                      ? "bg-menu_active"
                                      : ""
                                    }`}
                                >
                                  <span
                                    className={`inline-block float-left mr-3 ${window.location.pathname === "/patients"
                                        ? "patientListActiveImg"
                                        : "patientListImg"
                                      }`}
                                  ></span>
                                  <span
                                    className={`inline-block text-sm ${window.location.pathname === "/patients"
                                        ? "text-menuHvrColor font-semibold"
                                        : "menuTxt"
                                      }`}
                                  >
                                    PATIENT LIST
                                  </span>
                                </Link>
                              </li>
                              {access?.new_order === "T" && (
                                <li className="inline-block relative w-full">
                                  <Link
                                    to="/createOrder"
                                    className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full newOrderListmenuLi hover:text-menuHvrColor ${window.location.pathname ===
                                        "/createOrder"
                                        ? "bg-menu_active"
                                        : ""
                                      }`}
                                  >
                                    <span
                                      className={`inline-block float-left mr-3 ${window.location.pathname ===
                                          "/createOrder"
                                          ? "newOrderActiveImg"
                                          : "newOrderImg"
                                        }`}
                                    ></span>
                                    <span
                                      className={`inline-block text-sm ${window.location.pathname ===
                                          "/createOrder"
                                          ? "text-menuHvrColor font-semibold"
                                          : "menuTxt"
                                        }`}
                                    >
                                      NEW ORDER
                                    </span>
                                  </Link>
                                </li>
                              )}
                            </ul>
                          </li>
                            {(access?.batch_refill === "T" || access?.refill_due === "T") && (

                              <li className="inline-block relative w-full eom">
                                <span
                                  className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full refillListmenuLi hover:text-menuHvrColor ${window.location.pathname === "/refills"
                                    ? "bg-menu_active"
                                    : ""
                                    }`}
                                >
                                  <span
                                    className={`inline-block float-left mr-3 ${window.location.pathname === "/refills"
                                      ? "refillActiveImg"
                                      : "refillImg"
                                      }`}
                                  ></span>
                                  <span
                                    className={`inline-block w-1/2 text-sm ${window.location.pathname === "/refills"
                                      ? "text-menuHvrColor font-semibold"
                                      : "menuTxt"
                                      }`}
                                  >
                                    REFILLS
                                  </span>
                                </span>
                                <ul className="submenu2 bg-bodybgrnd absolute hidden z-50 text-white w-full left-full top-0">
                                  {access?.batch_refill === "T" && (<li className="inline-block relative w-full">
                                    <Link
                                      to="/refill"
                                      className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full batchRefillListmenuLi hover:text-menuHvrColor ${window.location.pathname === "/refill"
                                        ? "bg-menu_active"
                                        : ""
                                        }`}
                                    >
                                      <span
                                        className={`inline-block float-left mr-3 ${window.location.pathname === "/refill"
                                          ? "batchRefillActiveImg"
                                          : "batchRefillImg"
                                          }`}
                                      ></span>
                                      <span
                                        className={`inline-block text-sm ${window.location.pathname === "/refill"
                                          ? "text-menuHvrColor font-semibold"
                                          : ""
                                          }`}
                                      >
                                        BATCH REFILL
                                      </span>
                                    </Link>
                                  </li>)}

                                  {access?.refill_due === "T" && (
                                    <li className="inline-block relative w-full">
                                      <Link
                                        to="/refillDue"
                                        className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full batchRefillDueListmenuLi hover:text-menuHvrColor ${window.location.pathname ===
                                          "/refillDue"
                                          ? "bg-menu_active"
                                          : ""
                                          }`}
                                      >
                                        <span
                                          className={`inline-block float-left mr-3 ${window.location.pathname ===
                                            "/refillDue"
                                            ? "batchRefillDueActiveImg"
                                            : "batchRefillDueImg"
                                            }`}
                                        ></span>
                                        <span
                                          className={`inline-block text-sm ${window.location.pathname ===
                                            "/refillDue"
                                            ? "text-menuHvrColor font-semibold"
                                            : "menuTxt"
                                            }`}
                                        >
                                          REFILL DUE
                                        </span>
                                      </Link>
                                    </li>
                                  )}
                                </ul>
                              </li>
                            )}
                          {access?.non_form === "T" && (
                            <li className="inline-block relative w-full">
                              <Link
                                to="/nonforms"
                                className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full nonFormsListmenuLi hover:text-menuHvrColor ${window.location.pathname === "/nonforms"
                                    ? "bg-menu_active"
                                    : ""
                                  }`}
                              >
                                <span
                                  className={`inline-block float-left mr-3 ${window.location.pathname === "/nonforms"
                                      ? "nonFormsActiveImg"
                                      : "nonFormsImg"
                                    }`}
                                ></span>
                                <span
                                  className={`inline-block text-sm ${window.location.pathname === "/nonforms"
                                      ? "text-menuHvrColor font-semibold"
                                      : ""
                                    }`}
                                >
                                  NON FORMS
                                </span>
                              </Link>
                            </li>
                          )}
                          <li className="inline-block relative w-full">
                            <Link
                              to="/invoiceList"
                              className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full invoiceListmenuLi hover:text-menuHvrColor ${window.location.pathname === "/invoiceList"
                                  ? "bg-menu_active"
                                  : ""
                                }`}
                            >
                              <span
                                className={`inline-block float-left mr-3 ${window.location.pathname === "/invoiceList"
                                    ? "invoiceActiveImg"
                                    : "invoiceImg"
                                  }`}
                              ></span>
                              <span
                                className={`inline-block text-sm ${window.location.pathname === "/invoiceList"
                                    ? "text-menuHvrColor font-semibold"
                                    : "menuTxt"
                                  }`}
                              >
                                INVOICE LIST
                              </span>
                            </Link>
                          </li>
                          {access?.clarifications === "T" && (
                            <li className="inline-block relative w-full">
                              <Link
                                to="/clarifications"
                                className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full clarificationsListmenuLi hover:text-menuHvrColor ${window.location.pathname === "/clarifications"
                                  ? "bg-menu_active"
                                  : ""
                                  }`}
                              >
                                <span
                                  className={`inline-block float-left mr-3 ${window.location.pathname === "/clarifications"
                                    ? "clarificationsActiveImg"
                                    : "clarificationsImg"
                                    }`}
                                ></span>
                                <span
                                  className={`inline-block text-sm ${window.location.pathname === "/clarifications"
                                    ? "text-menuHvrColor font-semibold"
                                    : "menuTxt"
                                    }`}
                                >
                                  CLARIFICATIONS
                                </span>
                              </Link>
                            </li>
                          )}
                          {!isFLStockEnabled && (
                            <li className="inline-block relative w-full">
                              <Link to="/epcis-viewer" className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full epcisListmenuLi hover:text-menuHvrColor ${window.location.pathname.startsWith("/epcis-viewer") ? "bg-menu_active" : ""}`}>
                                <span className={`inline-block float-left mr-3 ${window.location.pathname.startsWith("/epcis-viewer") ? "epcisActiveImg" : "epcisImg"}`}></span>
                                <span className={`inline-block text-sm ${window.location.pathname.startsWith("/epcis-viewer") ? "text-menuHvrColor font-semibold" : "menuTxt"}`}>EPCIS FILES</span>
                              </Link>
                            </li>
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </ul>
                  ) : (
                    ""
                  )}
                </>

                {(user?.department === "ORDER_ENTRY" ||
                  user?.department === "FULFILLMENT") &&
                  user?.userType === "INTERNAL" ? (
                  <ul className="submenu bg-bodybgrnd absolute hidden z-50 text-white w-full">
                    <>
                      <li className="inline-block relative w-full">
                        <Link
                          to="/shipingScan"
                          className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full shippingMenuLi hover:text-menuHvrColor${window.location.pathname === "/shipingScan"
                              ? "bg-menu_active"
                              : ""
                            }`}
                        >
                          <span
                            className={`inline-block float-left mr-3 ${window.location.pathname === "/shipingScan"
                                ? "shippingActiveImg"
                                : "shippingImg"
                              }`}
                          ></span>
                          <span
                            className={`inline-block text-sm ${window.location.pathname === "/shipingScan"
                                ? "text-menuHvrColor font-semibold"
                                : "menuTxt"
                              }`}
                          >
                            SHIPING APP
                          </span>
                        </Link>
                      </li>
                      <li className="inline-block relative w-full">
                        <Link
                          to="/SorterScan"
                          className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full sorterScanMenuLi hover:text-menuHvrColor${window.location.pathname === "/SorterScan"
                              ? "bg-menu_active"
                              : ""
                            }`}
                        >
                          <span
                            className={`inline-block float-left mr-3 ${window.location.pathname === "/SorterScan"
                                ? "sorterScanActiveImg"
                                : "sorterScanImg"
                              }`}
                          ></span>
                          <span
                            className={`inline-block text-sm ${window.location.pathname === "/SorterScan"
                                ? "text-menuHvrColor font-semibold"
                                : "menuTxt"
                              }`}
                          >
                            SORTER SCAN
                          </span>
                        </Link>
                      </li>
                    </>
                    {user?.department === "FULFILLMENT" ? (
                      <li className="inline-block relative w-full">
                        <Link
                          to="/flowrackinventory"
                          className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full flowRackMenuLi hover:text-menuHvrColor ${window.location.pathname === "/flowrackinventory"
                              ? "bg-menu_active"
                              : ""
                            }`}
                        >
                          <span
                            className={`inline-block float-left mr-3 ${window.location.pathname === "/flowrackinventory"
                                ? "flowRackActiveImg"
                                : "flowRackImg"
                              }`}
                          ></span>
                          <span
                            className={`inline-block text-sm ${window.location.pathname === "/flowrackinventory"
                                ? "text-menuHvrColor font-semibold"
                                : "menuTxt"
                              }`}
                          >
                            FLOW RACK INVENTORY
                          </span>
                        </Link>
                      </li>
                    ) : (
                      ""
                    )}
                    {user?.department === "ORDER_ENTRY" ? (
                      <>
                        <li className="inline-block relative w-full">
                          <Link to="/flStockOrderForm" className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full stkOrderForm hover:text-menuHvrColor ${window.location.pathname === "/flStockOrderForm" ? "bg-menu_active" : ""}`}>
                            <span className={`inline-block float-left mr-3 ${window.location.pathname === "/flStockOrderForm" ? "stkOrderActiveImg" : "stkOrderImg"}`}></span>
                            <span className={`inline-block text-sm ${window.location.pathname === "/flStockOrderForm" ? "text-menuHvrColor font-semibold" : "menuTxt"}`}>FL STOCK ORDER FORM</span>
                          </Link>
                        </li>
                        <li className="inline-block relative w-full">
                          <Link
                            to="/claimSubmission"
                            className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full claimListmenuLi hover:text-menuHvrColor ${window.location.pathname === "/claimSubmission"
                                ? "bg-menu_active"
                                : ""
                              }`}
                          >
                            <span
                              className={`inline-block float-left mr-3 ${window.location.pathname === "/claimSubmission"
                                  ? "claimActiveImg"
                                  : "claimImg"
                                }`}
                            ></span>
                            <span
                              className={`inline-block text-sm ${window.location.pathname === "/claimSubmission"
                                  ? "text-menuHvrColor font-semibold"
                                  : "menuTxt"
                                }`}
                            >
                              CLAIM SUBMISSIONS
                            </span>
                          </Link>
                        </li>
                        <li className=" inline-block relative w-full">
                        <Link
                          to="/invalidOrderDrug"
                          className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full drugMisMatchListmenuLi hover:text-menuHvrColor ${window.location.pathname === "/invalidOrderDrug"
                              ? "bg-menu_active"
                              : ""
                            }`}
                        >
                          <span
                            className={`inline-block float-left mr-3 ${window.location.pathname === "/invalidOrderDrug"
                                ? "drugMisMatchActiveImg"
                                : "drugMisMatchImg"
                              }`}
                          ></span>
                          <span
                            className={`inline-block text-sm ${window.location.pathname === "/invalidOrderDrug"
                                ? "text-menuHvrColor font-semibold"
                                : "menuTxt"
                              }`}
                          >
                            DRUG MISMATCH
                          </span>
                        </Link>
                      </li>
                        <li className="inline-block relative w-full">
                            <Link
                              to="/faciltyRefillDue"
                              className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full batchRefillDueListmenuLi hover:text-menuHvrColor ${window.location.pathname ===
                                "/faciltyRefillDue"
                                ? "bg-menu_active"
                                : ""
                                }`}
                            >
                              <span
                                className={`inline-block float-left mr-3 ${window.location.pathname ===
                                  "/faciltyRefillDue"
                                  ? "batchRefillDueActiveImg"
                                  : "batchRefillDueImg"
                                  }`}
                              ></span>
                              <span
                                className={`inline-block text-sm ${window.location.pathname ===
                                  "/faciltyRefillDue"
                                  ? "text-menuHvrColor font-semibold"
                                  : "menuTxt"
                                  }`}
                              >
                                REFILL DUE
                              </span>
                            </Link>
                        </li>
                        <li className="inline-block relative w-full">
                          <Link
                            to="/replacements"
                            className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full replacementsMenuLi hover:text-menuHvrColor ${window.location.pathname === "/replacements"
                                ? "bg-menu_active"
                                : ""
                              }`}
                          >
                            <span
                              className={`inline-block float-left mr-3 ${window.location.pathname === "/replacements"
                                  ? "replacementsActiveImg"
                                  : "replacementsImg"
                                }`}
                            ></span>
                            <span
                              className={`inline-block text-sm ${window.location.pathname === "/replacements"
                                  ? "text-menuHvrColor font-semibold"
                                  : "menuTxt"
                                }`}
                            >
                              REPLACEMENTS AND RERUNS
                            </span>
                          </Link>
                        </li>
                        <li className="inline-block relative w-full">
                          <Link
                            to="/stocks"
                            className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full stkOrderForm hover:text-menuHvrColor${window.location.pathname === "/stocks"
                                ? "bg-menu_active"
                                : ""
                              }`}
                          >
                            <span
                              className={`inline-block float-left mr-3 ${window.location.pathname === "/stocks"
                                  ? "stkOrderActiveImg"
                                  : "stkOrderImg"
                                }`}
                            ></span>
                            <span
                              className={`inline-block text-sm ${window.location.pathname === "/stocks"
                                  ? "text-menuHvrColor font-semibold"
                                  : ""
                                }`}
                            >
                              STOCK ORDER FORM
                            </span>
                          </Link>
                        </li>
                        <li className="inline-block relative w-full">
                          <Link
                            to="/copyDrugs"
                            className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full hover:text-menuHvrColor cpyDrgForm ${window.location.pathname === "/copyDrugs"
                                ? "bg-menu_active"
                                : ""
                              }`}
                          >
                            <span
                              className={`inline-block float-left mr-3 ${window.location.pathname === "/copyDrugs"
                                  ? "cpyDrgActiveImg"
                                  : "cpyDrgImg"
                                }`}
                            ></span>
                            <span
                              className={`inline-block text-sm ${window.location.pathname === "/copyDrugs"
                                  ? "text-menuHvrColor font-semibold"
                                  : "menuTxt"
                                }`}
                            >
                              COPY STOCK FORM
                            </span>
                          </Link>
                        </li>
                        {/* <li className="inline-block  relative w-full">
                          <Link
                            to="/uploadDocuments"
                            className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full appmenuLi hover:text-menuHvrColor cpyDrgForm ${
                              window.location.pathname === "/uploadDocuments"
                                ? "bg-menu_active"
                                : ""
                            }`}
                          >
                            <span
                              className={`inline-block float-left mr-3 ${
                                window.location.pathname === "/uploadDocuments"
                                  ? "uploadActiveImg"
                                  : "uploadImg"
                              }`}
                            ></span>
                            <span
                              className={`inline-block text-sm ${
                                window.location.pathname === "/uploadDocuments"
                                  ? "text-menuHvrColor font-semibold"
                                  : "menuTxt"
                              }`}
                            >
                              UPLOAD DOCUMENTS
                            </span>
                          </Link>
                        </li> */}
                        {user?.userRole === "DEPARTMENT_ADMIN" ? (
                          <li className="inline-block relative w-full">
                            <Link
                              to="/refillTime"
                              className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full appmenuLi hover:text-menuHvrColor${window.location.pathname === "/refillTime"
                                  ? "bg-menu_active"
                                  : ""
                                }`}
                            >
                              <span
                                className={`inline-block float-left mr-3 ${window.location.pathname === "/refillTime"
                                    ? "refillTimeActiveImg"
                                    : "refillTimeImg"
                                  }`}
                              ></span>
                              <span
                                className={`inline-block text-sm ${window.location.pathname === "/refillTime"
                                    ? "text-menuHvrColor font-semibold"
                                    : ""
                                  }`}
                              >
                                REFILL TIME
                              </span>
                            </Link>
                          </li>
                        ) : (
                          ""
                        )}
                      </>
                    ) : (
                      ""
                    )}

                  </ul>
                ) : (
                  ""
                )}
                {user?.department === "ACCOUNTING" &&
                  user?.userRole === "DEPARTMENT_ADMIN" ? (
                  <>
                    <ul className="submenu bg-bodybgrnd absolute hidden z-50 text-white w-full ">
                      <li className="inline-block relative w-full">
                        <Link
                          to="/invoice"
                          className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full hover:text-menuHvrColor invoiceListmenuLi ${window.location.pathname === "/invoice"
                              ? "bg-menu_active"
                              : ""
                            }`}
                        >
                          <span
                            className={`inline-block float-left mr-3 ${window.location.pathname === "/invoice"
                                ? "invoiceActiveImg"
                                : "invoiceImg"
                              }`}
                          ></span>
                          <span
                            className={`inline-block text-sm ${window.location.pathname === "/invoice"
                                ? "text-menuHvrColor font-semibold"
                                : "menuTxt"
                              }`}
                          >
                            INVOICING
                          </span>
                        </Link>
                      </li>
                      <li className="inline-block relative w-full">
                        <Link
                          to="/claimSubmission"
                          className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full claimListmenuLi hover:text-menuHvrColor ${window.location.pathname === "/claimSubmission"
                              ? "bg-menu_active"
                              : ""
                            }`}
                        >
                          <span
                            className={`inline-block float-left mr-3 ${window.location.pathname === "/claimSubmission"
                                ? "claimActiveImg"
                                : "claimImg"
                              }`}
                          ></span>
                          <span
                            className={`inline-block text-sm ${window.location.pathname === "/claimSubmission"
                                ? "text-menuHvrColor font-semibold"
                                : "menuTxt"
                              }`}
                          >
                            CLAIM SUBMISSIONS
                          </span>
                        </Link>
                      </li>
                      <li className="inline-block relative w-full">
                        <Link
                          to="/invalidOrderDrug"
                          className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full drugMisMatchListmenuLi hover:text-menuHvrColor ${window.location.pathname === "/invalidOrderDrug"
                              ? "bg-menu_active"
                              : ""
                            }`}
                        >
                          <span
                            className={`inline-block float-left mr-3 ${window.location.pathname === "/invalidOrderDrug"
                                ? "drugMisMatchActiveImg"
                                : "drugMisMatchImg"
                              }`}
                          ></span>
                          <span
                            className={`inline-block text-sm ${window.location.pathname === "/invalidOrderDrug"
                                ? "text-menuHvrColor font-semibold"
                                : "menuTxt"
                              }`}
                          >
                            DRUG MISMATCH
                          </span>
                        </Link>
                      </li>
                      {user?.department === "ACCOUNTING" ? (
                        <>
                          <li className="inline-block relative w-full eom">
                            <span
                              className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full eomListmenuLi hover:text-menuHvrColor ${window.location.pathname === "/eom"
                                  ? "bg-menu_active"
                                  : ""
                                }`}
                            >
                              <span
                                className={`inline-block float-left mr-3 ${window.location.pathname === "/eom"
                                    ? "eomActiveImg"
                                    : "eomImg"
                                  }`}
                              ></span>
                              <span
                                className={`inline-block w-1/2 text-sm ${window.location.pathname === "/eom"
                                    ? "text-menuHvrColor font-semibold"
                                    : "menuTxt"
                                  }`}
                              >
                                EOM
                              </span>
                            </span>
                            <ul className="submenu2 bg-bodybgrnd absolute hidden z-50 text-white w-full left-full top-0">
                              <li className="inline-block relative w-full">
                                <Link
                                  to="/eom"
                                  className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full eomGenerationListmenuLi hover:text-menuHvrColor ${window.location.pathname === "/eom"
                                      ? "bg-menu_active"
                                      : ""
                                    }`}
                                >
                                  <span
                                    className={`inline-block float-left mr-3 ${window.location.pathname === "/eom"
                                        ? "eomGenerationActiveImg"
                                        : "eomGenerationImg"
                                      }`}
                                  ></span>
                                  <span
                                    className={`inline-block text-sm ${window.location.pathname === "/eom"
                                        ? "text-menuHvrColor font-semibold"
                                        : "menuTxt"
                                      }`}
                                  >
                                    GENERATE EOM
                                  </span>
                                </Link>
                              </li>
                              <li className="inline-block relative w-full">
                                <Link
                                  to="/eomFiles"
                                  className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full eomFilesListmenuLi hover:text-menuHvrColor ${window.location.pathname === "/eomFiles"
                                      ? "bg-menu_active"
                                      : ""
                                    }`}
                                >
                                  <span
                                    className={`inline-block float-left mr-3 ${window.location.pathname === "/eomFiles"
                                        ? "eomFilesActiveImg"
                                        : "eomFilesImg"
                                      }`}
                                  ></span>
                                  <span
                                    className={`inline-block text-sm ${window.location.pathname === "/eomFiles"
                                        ? "text-menuHvrColor font-semibold"
                                        : "menuTxt"
                                      }`}
                                  >
                                    EOM FILES
                                  </span>
                                </Link>
                              </li>
                            </ul>
                          </li>
                        </>
                      ) : (
                        ""
                      )}
                    </ul>
                  </>
                ) : (
                  ""
                )}

                {user?.department === "ACCOUNTING" &&
                  user?.userRole === "DEPARTMENT_USER" ? (
                  <>
                    <ul className="submenu bg-bodybgrnd absolute hidden z-50 text-white w-full ">
                      <li className="inline-block relative w-full eom">
                        <span
                          className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full invoiceListmenuLi hover:text-menuHvrColor ${window.location.pathname === "/eom"
                              ? "bg-menu_active"
                              : ""
                            }`}
                        >
                          <span
                            className={`inline-block float-left mr-3 ${window.location.pathname === "/eom"
                                ? "invoiceActiveImg"
                                : "invoiceImg"
                              }`}
                          ></span>
                          <span
                            className={`inline-block w-1/2 text-sm ${window.location.pathname === "/eom"
                                ? "text-menuHvrColor font-semibold"
                                : "menuTxt"
                              }`}
                          >
                            EOM
                          </span>
                        </span>
                        <ul className="submenu2 bg-bodybgrnd absolute hidden z-50 text-white w-full left-full top-0">
                          <li className="inline-block relative w-full">
                            <Link
                              to="/eom"
                              className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full invoiceListmenuLi hover:text-menuHvrColor ${window.location.pathname === "/eom"
                                  ? "bg-menu_active"
                                  : ""
                                }`}
                            >
                              <span
                                className={`inline-block float-left mr-3 ${window.location.pathname === "/eom"
                                    ? "invoiceActiveImg"
                                    : "invoiceImg"
                                  }`}
                              ></span>
                              <span
                                className={`inline-block text-sm ${window.location.pathname === "/eom"
                                    ? "text-menuHvrColor font-semibold"
                                    : "menuTxt"
                                  }`}
                              >
                                GENERATE EOM
                              </span>
                            </Link>
                          </li>
                          <li className="inline-block relative w-full">
                            <Link
                              to="/eomFiles"
                              className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full invoiceListmenuLi hover:text-menuHvrColor ${window.location.pathname === "/eomFiles"
                                  ? "bg-menu_active"
                                  : ""
                                }`}
                            >
                              <span
                                className={`inline-block float-left mr-3 ${window.location.pathname === "/eomFiles"
                                    ? "invoiceActiveImg"
                                    : "invoiceImg"
                                  }`}
                              ></span>
                              <span
                                className={`inline-block text-sm ${window.location.pathname === "/eomFiles"
                                    ? "text-menuHvrColor font-semibold"
                                    : "menuTxt"
                                  }`}
                              >
                                EOM FILES
                              </span>
                            </Link>
                          </li>


                        </ul>
                      </li>
                      <li className="inline-block relative w-full">
                        <Link
                          to="/claimSubmission"
                          className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full claimListmenuLi hover:text-menuHvrColor ${window.location.pathname === "/claimSubmission"
                              ? "bg-menu_active"
                              : ""
                            }`}
                        >
                          <span
                            className={`inline-block float-left mr-3 ${window.location.pathname === "/claimSubmission"
                                ? "claimActiveImg"
                                : "claimImg"
                              }`}
                          ></span>
                          <span
                            className={`inline-block text-sm ${window.location.pathname === "/claimSubmission"
                                ? "text-menuHvrColor font-semibold"
                                : "menuTxt"
                              }`}
                          >
                            CLAIM SUBMISSIONS
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </>
                ) : (
                  ""
                )}
                {user?.department === "CLINICAL" ? (
                  <>
                    <ul className="submenu bg-bodybgrnd absolute hidden z-50 text-white w-full ">
                      <li className="inline-block relative w-full">
                        <Link
                          to="/nonformsSuggestion"
                          className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full hover:text-menuHvrColor nonFormsSuggestionListmenuLi ${window.location.pathname === "/nonformsSuggestion"
                              ? "bg-menu_active"
                              : ""
                            }`}
                        >
                          <span
                            className={`inline-block float-left mr-3 ${window.location.pathname === "/nonformsSuggestion"
                                ? "nonFormsSuggestionActiveImg"
                                : "nonFormsSuggestionImg"
                              }`}
                          ></span>
                          <span
                            className={`inline-block mt-1 text-sm ${window.location.pathname === "/nonformsSuggestion"
                                ? "text-menuHvrColor font-semibold"
                                : ""
                              }`}
                          >
                            NON FORM SUGGESTION
                          </span>
                        </Link>
                      </li>
                      <li className="inline-block relative w-full">
                        <Link
                          to="/invalidOrderDrug"
                          className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full drugMisMatchListmenuLi hover:text-menuHvrColor ${window.location.pathname === "/invalidOrderDrug"
                              ? "bg-menu_active"
                              : ""
                            }`}
                        >
                          <span
                            className={`inline-block float-left mr-3 ${window.location.pathname === "/invalidOrderDrug"
                                ? "drugMisMatchActiveImg"
                                : "drugMisMatchImg"
                              }`}
                          ></span>
                          <span
                            className={`inline-block text-sm ${window.location.pathname === "/invalidOrderDrug"
                                ? "text-menuHvrColor font-semibold"
                                : "menuTxt"
                              }`}
                          >
                            DRUG MISMATCH
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </>
                ) : (
                  ""
                )}
                {user?.department === "INVENTORY" ? (
                  <>
                    <ul className="submenu bg-bodybgrnd absolute hidden z-50 text-white w-full ">
                      <li className="inline-block relative w-full">
                        <Link
                          to="/replacements"
                          className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full replacementsMenuLi hover:text-menuHvrColor ${window.location.pathname === "/replacements"
                              ? "bg-menu_active"
                              : ""
                            }`}
                        >
                          <span
                            className={`inline-block float-left mr-3 ${window.location.pathname === "/replacements"
                                ? "replacementsActiveImg"
                                : "replacementsImg"
                              }`}
                          ></span>
                          <span
                            className={`inline-block text-sm ${window.location.pathname === "/replacements"
                                ? "text-menuHvrColor font-semibold"
                                : "menuTxt"
                              }`}
                          >
                            REPLACEMENTS AND RERUNS
                          </span>
                        </Link>
                      </li>
                      <li className="inline-block relative w-full">
                        <Link
                          to="/flowrackinventory"
                          className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full flowRackMenuLi hover:text-menuHvrColor ${window.location.pathname === "/flowrackinventory"
                              ? "bg-menu_active"
                              : ""
                            }`}
                        >
                          <span
                            className={`inline-block float-left mr-3 ${window.location.pathname === "/flowrackinventory"
                                ? "flowRackActiveImg"
                                : "flowRackImg"
                              }`}
                          ></span>
                          <span
                            className={`inline-block text-sm ${window.location.pathname === "/flowrackinventory"
                                ? "text-menuHvrColor font-semibold"
                                : "menuTxt"
                              }`}
                          >
                            FLOW RACK INVENTORY
                          </span>
                        </Link>
                      </li>
                      <li className="inline-block relative w-full">
                        <Link to="/flStockOrderForm" className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full stkOrderForm hover:text-menuHvrColor ${window.location.pathname === "/flStockOrderForm" ? "bg-menu_active" : ""}`}>
                          <span className={`inline-block float-left mr-3 ${window.location.pathname === "/flStockOrderForm" ? "stkOrderActiveImg" : "stkOrderImg"}`}></span>
                          <span className={`inline-block text-sm ${window.location.pathname === "/flStockOrderForm" ? "text-menuHvrColor font-semibold" : "menuTxt"}`}>FL STOCK ORDER FORM</span>
                        </Link>
                      </li>
                    </ul>
                  </>
                ) : (
                  ""
                )}
              </li>}
              { access?.emar === 'T' && <li className="inline-block relative leading-8 mr-4">
              <button
                  className={`block py-3 px-8 rounded-lg rounded-b-none cursor-pointer hover:bg-bodybgrnd customMargin emarListmenuLi hover:text-menuHvrColor ${
                    window.location.pathname === "/configure" ||
                    window.location.pathname === "/createStatMeds" ||
                    window.location.pathname === "/medpass" ||
                    window.location.pathname === "/kop" ||
                    window.location.pathname === "/addendum-medpass" ||
                    window.location.pathname === "/medHistory"
                      ? "bg-bodybgrnd menuHvrBorder"
                      : ""
                    }`}
                >
                  <span
                    className={`inline-block float-left mr-3 w-6 h-8 ${
                        window.location.pathname === "/configure" ||
                        window.location.pathname === "/createStatMeds" ||
                        window.location.pathname === "/medpass" ||
                        window.location.pathname === "/kop" ||
                        window.location.pathname === "/addendum-medpass" ||
                        window.location.pathname === "/medHistory"
                        ? "emarActiveImg"
                        : "emarImg"
                      }`}
                  ></span>
                  <span
                    className={`inline-block text-sm ${
                        window.location.pathname === "/configure" ||
                        window.location.pathname === "/createStatMeds" ||
                        window.location.pathname === "/medpass" ||
                        window.location.pathname === "/kop" ||
                        window.location.pathname === "/addendum-medpass" ||
                        window.location.pathname === "/medHistory"
                        ? "text-menuHvrColor font-semibold"
                        : ""
                      }`}
                  >
                    EMAR
                  </span>
                </button>
                <ul className="submenu bg-bodybgrnd absolute hidden z-50 text-white  w-56">
                      {user.userRole !== "PROVIDER" && <li className="inline-block relative w-full">
                        <Link
                          to="/configure"
                          className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full emarListmenuLi  hover:text-menuHvrColor ${window.location.pathname === "/configure"
                              ? "bg-menu_active"
                              : ""
                            }`}
                        >
                          <span
                            className={`inline-block float-left mr-3 ${window.location.pathname === "/configure"
                                ? "emarMedpassConfigActiveImg"
                                : "emarMedpassConfigImg"
                              }`}
                          >
                          </span>
                          <span
                            className={`inline-block text-sm ${window.location.pathname === "/configure"
                                ? "text-menuHvrColor font-semibold"
                                : "menuTxt"
                              }`}
                          >
                            CONFIGURE
                          </span>
                        </Link>
                      </li>}
                      {user.userRole !== "PROVIDER"&&  <li className="inline-block relative w-full">
                        <Link
                          to="/createStatMeds"
                          className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full emarListmenuLi  hover:text-menuHvrColor ${window.location.pathname === "/configure"
                              ? "bg-menu_active"
                              : ""
                            }`}
                        >
                          <span
                            className={`inline-block float-left mr-3 ${window.location.pathname === "/createStatMeds"
                                ? "emarMedpassConfigActiveImg"
                                : "emarMedpassConfigImg"
                              }`}
                          >
                          </span>
                          <span
                            className={`inline-block text-sm ${window.location.pathname === "/createStatMeds"
                                ? "text-menuHvrColor font-semibold"
                                : "menuTxt"
                              }`}
                          >
                           ADD STATMEDS
                          </span>
                        </Link>
                      </li>}
                      {user.userRole !== "PROVIDER" &&  <li className="inline-block relative w-full">
                        <Link
                          to="/kop"
                          className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full emarListmenuLi  hover:text-menuHvrColor ${window.location.pathname === "/kop"
                              ? "bg-menu_active"
                              : ""
                            }`}
                        >
                          <span
                            className={`inline-block float-left mr-2 ${window.location.pathname === "/kop"
                                ? "emarMedpassActiveImg"
                                : "emarMedpassImg"
                              }`}
                          >
                          </span>
                          <span
                            className={`inline-block text-sm ${window.location.pathname === "/kop"
                                ? "text-menuHvrColor font-semibold"
                                : "menuTxt"
                              }`}
                          >
                            KOP MEDPASS
                          </span>
                        </Link>
                      </li>}
                      {user.userRole !== "PROVIDER" &&  <li className="inline-block relative w-full">
                        <Link
                          to="/medpass"
                          className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full emarListmenuLi  hover:text-menuHvrColor ${window.location.pathname === "/medpass"
                              ? "bg-menu_active"
                              : ""
                            }`}
                        >
                          <span
                            className={`inline-block float-left mr-2 ${window.location.pathname === "/medpass"
                                ? "emarMedpassActiveImg"
                                : "emarMedpassImg"
                              }`}
                          >
                          </span>
                          <span
                            className={`inline-block text-sm ${window.location.pathname === "/medpass"
                                ? "text-menuHvrColor font-semibold"
                                : "menuTxt"
                              }`}
                          >
                            DOT MEDPASS
                          </span>
                        </Link>
                      </li>}
                      {user.userRole !== "PROVIDER" &&  <li className="inline-block relative w-full">
                        <Link
                          to="/addendum-medpass"
                          className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full emarListmenuLi  hover:text-menuHvrColor ${window.location.pathname === "/addendum-medpass"
                              ? "bg-menu_active"
                              : ""
                            }`}
                        >
                          <span
                            className={`inline-block float-left mr-2 ${window.location.pathname === "/addendum-medpass"
                                ? "emarMedpassActiveImg"
                                : "emarMedpassImg"
                              }`}
                          >
                          </span>
                          <span
                            className={`inline-block text-sm ${window.location.pathname === "/addendum-medpass"
                                ? "text-menuHvrColor font-semibold"
                                : "menuTxt"
                              }`}
                          >
                            ADDENDUM MEDPASS
                          </span>
                        </Link>
                      </li>}
                      <li className="inline-block relative w-full">
                        <Link
                          to="/medHistory"
                          className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full emarListmenuLi  hover:text-menuHvrColor ${window.location.pathname === "/medHistory"
                              ? "bg-menu_active"
                              : ""
                            }`}
                        >
                          <span
                            className={`inline-block float-left mr-3 ${window.location.pathname === "/medHistory"
                                ? "emarHistoryActiveImg"
                                : "emarHistoryImg"
                              }`}
                          >
                          </span>
                          <span
                            className={`inline-block text-sm ${window.location.pathname === "/medHistory"
                                ? "text-menuHvrColor font-semibold"
                                : "menuTxt"
                              }`}
                          >
                            VIEW MAR
                          </span>
                        </Link>
                      </li>
                      </ul>
              </li>}
              {user.userRole !== "EMAR_USER" &&  user.userRole !== "PROVIDER" &&  <>
                {user?.userType === "INTERNAL" ? (
                  <li className="inline-block relative leading-8 mr-4">
                    <button
                      to=""
                      className={`block py-3 px-12 rounded-lg rounded-b-none cursor-pointer hover:bg-bodybgrnd customMargin reportmenuLi  hover:text-menuHvrColor ${window.location.pathname === "/expirationReport" ||
                          window.location.pathname === "/expirationPage" ||
                          window.location.pathname === "/orderEntryDashboard" ||
                          window.location.pathname === "/shipingReport" ||
                          window.location.pathname === "/ssrs/:type" ||
                          window.location.pathname === "/stocksReports"
                          ? "bg-bodybgrnd menuHvrBorder"
                          : ""
                        }`}
                    >
                      <span
                        className={`inline-block float-left mr-2  ${window.location.pathname === "/expirationReport" ||
                            window.location.pathname === "/expirationPage" ||
                            window.location.pathname === "/orderEntryDashboard" ||
                            window.location.pathname === "/shipingReport" ||
                            window.location.pathname === "/ssrs/:type" ||
                            window.location.pathname === "/stocksReports"
                            ? "reportActiveImg"
                            : "reportImg"
                          }`}
                      ></span>
                      <span
                        className={`inline-block text-sm ${window.location.pathname === "/expirationReport" ||
                            window.location.pathname === "/expirationPage" ||
                            window.location.pathname === "/orderEntryDashboard" ||
                            window.location.pathname === "/shipingReport" ||
                            window.location.pathname === "/ssrs/:type" ||
                            window.location.pathname === "/stocksReports"
                            ? "text-menuHvrColor font-semibold"
                            : "menuTxt"
                          }`}
                      >
                        REPORTS
                      </span>
                    </button>
                    <ul className="submenu bg-bodybgrnd absolute hidden z-50 text-white w-full ">
                      {user?.department === "ORDER_ENTRY" ? (
                        <>
                          <li className="inline-block relative w-full">
                            <Link
                              to="/expirationReport"
                              className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full hover:text-menuHvrColor .expRepListmenuLi:hover .expirationRepImg,
                              ${window.location.pathname === "/expirationReport"
                                  ? "bg-menu_active"
                                  : ""
                                }`}
                            >
                              <span
                                className={`inline-block float-left mr-3 ${window.location.pathname ===
                                    "/expirationReport"
                                    ? "expirationRepActiveImg"
                                    : "expirationRepImg"
                                  }`}
                              ></span>
                              <span
                                className={`inline-block text-sm ${window.location.pathname ===
                                    "/expirationReport"
                                    ? "text-menuHvrColor font-semibold"
                                    : ""
                                  }`}
                              >
                                SCRIPT EXPIRATION REPORT
                              </span>
                            </Link>
                          </li>
                          <li className="inline-block relative w-full">
                            <Link
                              to="/stocksReports"
                              className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full hover:text-menuHvrColor stkRepLi ${window.location.pathname === "/stocksReports"
                                  ? "bg-menu_active"
                                  : ""
                                }`}
                            >
                              <span
                                className={`inline-block float-left mr-3 ${window.location.pathname === "/stocksReports"
                                    ? "stkRepActiveImg"
                                    : "stkImg "
                                  }`}
                              ></span>
                              <span
                                className={`inline-block text-sm ${window.location.pathname === "/stocksReports"
                                    ? "text-menuHvrColor font-semibold"
                                    : ""
                                  }`}
                              >
                                STOCKS REPORTS
                              </span>
                            </Link>
                          </li>
                        </>
                      ) : (
                        ""
                      )}

                      <>
                        {user?.department === "ORDER_ENTRY" ||
                          user?.department === "FULFILLMENT" ? (
                          <>
                            <li className="inline-block relative w-full">
                              <Link
                                to="/orderEntryDashboard"
                                className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full hover:text-menuHvrColor oeDashboardLi ${window.location.pathname ===
                                    "/orderEntryDashboard"
                                    ? "bg-menu_active"
                                    : ""
                                  }`}
                              >
                                <span
                                  className={`inline-block float-left mr-3 ${window.location.pathname ===
                                      "/orderEntryDashboard"
                                      ? "oeActiveImg"
                                      : "oeImg"
                                    }`}
                                ></span>
                                <span
                                  className={`inline-block mt-1 text-sm ${window.location.pathname ===
                                      "/orderEntryDashboard"
                                      ? "text-menuHvrColor font-semibold"
                                      : ""
                                    }`}
                                >
                                  OE-FULFILLMENT DASHBOARD
                                </span>
                              </Link>
                            </li>
                            <li className="inline-block relative w-full">
                              <Link
                                to="/shipingReport"
                                className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full hover:text-menuHvrColor auditRepLi ${window.location.pathname === "/shipingReport"
                                    ? "bg-menu_active"
                                    : ""
                                  }`}
                              >
                                <span
                                  className={`inline-block float-left mr-3 ${window.location.pathname ===
                                      "/shipingReport"
                                      ? "auditRepActiveImg"
                                      : "auditRepImg"
                                    }`}
                                ></span>
                                <span
                                  className={`inline-block text-sm ${window.location.pathname ===
                                      "/shipingReport"
                                      ? "text-menuHvrColor font-semibold"
                                      : ""
                                    }`}
                                >
                                  AUDIT REPORT
                                </span>
                              </Link>
                            </li>
                          </>
                        ) : (
                          ""
                        )}
                      </>
                      <>
                        {user?.department === "ACCOUNTING" &&
                          user?.userRole === "DEPARTMENT_ADMIN" ? (
                          <>
                            <li className="inline-block relative w-full">
                              <Link
                                to="/managementReport"
                                className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full hover:text-menuHvrColor mngRepLi${window.location.pathname ===
                                    "/managementReport"
                                    ? "bg-menu_active"
                                    : ""
                                  }`}
                              >
                                <span
                                  className={`inline-block float-left mr-3 ${window.location.pathname ===
                                      "/managementReport"
                                      ? "mngRepActiveImg"
                                      : "mngRepImg"
                                    }`}
                                ></span>
                                <span
                                  className={`inline-block text-sm ${window.location.pathname ===
                                      "/managementReport"
                                      ? "text-menuHvrColor font-semibold"
                                      : ""
                                    }`}
                                >
                                  MANAGEMENT REPORTS
                                </span>
                              </Link>
                            </li>
                          </>
                        ) : (
                          ""
                        )}
                      </>
                      {types.length > 0 &&
                        types.map((item, i) => {
                          return (
                            <li className="inline-block relative w-full" key={i}>
                              <Link
                                to={"/ssrs/" + item}
                                className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full hover:text-menuHvrColor publishlistLi ${window.location.pathname ===
                                    `"/ssrs/"+${item}`
                                    ? "bg-menu_active"
                                    : ""
                                  }`}
                              >
                                <span
                                  className={`inline-block float-left mr-3 ${window.location.pathname ===
                                      `"/ssrs/"+${item}`
                                      ? "publishlistActiveImg"
                                      : "publishlistImg"
                                    }`}
                                ></span>
                                <span
                                  className={`inline-block text-sm ${window.location.pathname ===
                                      `"/ssrs/"+${item}`
                                      ? "text-menuHvrColor font-semibold"
                                      : ""
                                    }`}
                                >
                                  {item} REPORTS
                                </span>
                              </Link>
                            </li>
                          );
                        })}
                    </ul>
                  </li>
                ) : (
                  ""
                )}
              </>}
              {user.userRole !== "EMAR_USER" && user.userRole !== "PROVIDER" && <>
                {user?.userType === "EXTERNAL" ? (
                  <li className="inline-block relative leading-8 mr-4">
                    <button
                      className={`block py-3 px-8 rounded-lg rounded-b-none cursor-pointer hover:bg-bodybgrnd hover:text-menuHvrColor reportmenuLi ${window.location.pathname === "/expirationReport" ||
                          window.location.pathname === "/expirationPage" ||
                          window.location.pathname === "/orderEntryDashboard" ||
                          window.location.pathname === "/stocksReports" ||
                          window.location.pathname === "/flStockReports" ||
                          window.location.pathname === "/publishList" ||
                          window.location.pathname === "/forms/rmf" ||
                          window.location.pathname === "/ssrs/:type" ||
                          window.location.pathname === "/forms/kop"
                          ? "bg-bodybgrnd menuHvrBorder"
                          : ""
                        }`}
                    >
                      <span
                        className={`inline-block float-left mr-2  ${window.location.pathname === "/expirationReport" ||
                            window.location.pathname === "/expirationPage" ||
                            window.location.pathname === "/orderEntryDashboard" ||
                            window.location.pathname === "/stocksReports" ||
                            window.location.pathname === "/flStockReports" ||
                            window.location.pathname === "/publishList" ||
                            window.location.pathname === "/forms/rmf" ||
                            window.location.pathname === "/ssrs/:type" ||
                            window.location.pathname === "/forms/kop"
                            ? "reportActiveImg"
                            : "reportImg"
                          }`}
                      ></span>
                      <span
                        className={`inline-block text-sm ${window.location.pathname === "/expirationReport" ||
                            window.location.pathname === "/expirationPage" ||
                            window.location.pathname === "/orderEntryDashboard" ||
                            window.location.pathname === "/stocksReports" ||
                            window.location.pathname === "/flStockReports" ||
                            window.location.pathname === "/publishList" ||
                            window.location.pathname === "/forms/rmf" ||
                            window.location.pathname === "/ssrs/:type" ||
                            window.location.pathname === "/forms/kop"
                            ? "text-menuHvrColor font-semibold"
                            : ""
                          }`}
                      >
                        REPORTS
                      </span>
                    </button>
                    <ul className="submenu bg-bodybgrnd absolute hidden z-50 text-white w-56 ">
                      <li className="inline-block relative w-full">
                        <Link
                          to="/publishList"
                          className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full hover:text-menuHvrColor publishlistLi ${window.location.pathname === "/publishList"
                              ? "bg-menu_active"
                              : ""
                            }`}
                        >
                          <span
                            className={`inline-block float-left mr-3 ${window.location.pathname === "/publishList"
                                ? "publishlistActiveImg"
                                : "publishlistImg"
                              }`}
                          ></span>
                          <span
                            className={`inline-block text-sm ${window.location.pathname === "/publishList"
                                ? "text-menuHvrColor font-semibold"
                                : ""
                              }`}
                          >
                            PACKING SLIPS
                          </span>
                        </Link>
                      </li>
                      {types.length > 0 &&
                        types.map((item, i) => {
                          return (
                            <li className="inline-block relative w-full" key={i}>
                              <Link
                                to={"/ssrs/" + item}
                                className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full hover:text-menuHvrColor publishlistLi ${window.location.pathname ===
                                    `"/ssrs/"+${item}`
                                    ? "bg-menu_active"
                                    : ""
                                  }`}
                              >
                                <span
                                  className={`inline-block float-left mr-3 ${window.location.pathname ===
                                      `"/ssrs/"+${item}`
                                      ? "publishlistActiveImg"
                                      : "publishlistImg"
                                    }`}
                                ></span>
                                <span
                                  className={`inline-block text-sm ${window.location.pathname ===
                                      `"/ssrs/"+${item}`
                                      ? "text-menuHvrColor font-semibold"
                                      : ""
                                    }`}
                                >
                                  {item} REPORTS
                                </span>
                              </Link>
                            </li>
                          );
                        })}
                      {user?.userType === "EXTERNAL" &&
                        (user.userRole === "FACILITY_USER" ||
                          user.userRole === "FACILITY_ADMIN") ? (
                        <>
                          {!isFLStockEnabled && (
                            <li className="inline-block relative w-full">
                              <Link
                                to="/stocksReports"
                                className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full hover:text-menuHvrColor stkRepLi ${window.location.pathname === "/stocksReports"
                                    ? "bg-menu_active"
                                    : ""
                                  }`}
                              >
                                <span
                                  className={`inline-block float-left mr-3 ${window.location.pathname === "/stocksReports"
                                      ? "stkRepActiveImg"
                                      : "stkImg"
                                    }`}
                                ></span>
                                <span
                                  className={`inline-block text-sm ${window.location.pathname === "/stocksReports"
                                      ? "text-menuHvrColor font-semibold"
                                      : ""
                                    }`}
                                >
                                  STOCKS REPORTS
                                </span>
                              </Link>
                            </li>
                          )}
                          {isFLStockEnabled && (
                            <li className="inline-block relative w-full">
                              <Link
                                to="/flStockReports"
                                className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full hover:text-menuHvrColor stkRepLi ${window.location.pathname === "/flStockReports"
                                    ? "bg-menu_active"
                                    : ""
                                  }`}
                              >
                                <span
                                  className={`inline-block float-left mr-3 ${window.location.pathname === "/flStockReports"
                                      ? "stkRepActiveImg"
                                      : "stkImg"
                                    }`}
                                ></span>
                                <span
                                  className={`inline-block text-sm ${window.location.pathname === "/flStockReports"
                                      ? "text-menuHvrColor font-semibold"
                                      : ""
                                    }`}
                                >
                                  FL STOCK REPORTS
                                </span>
                              </Link>
                            </li>
                          )}
                        </>
                      ) : (
                        ""
                      )}
                      {user?.facility === 1492 ? (
                        <>
                          <li className="inline-block relative w-full">
                            <Link
                              to="/forms/kop"
                              className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full hover:text-menuHvrColor kopLi${window.location.pathname === "/forms/kop"
                                  ? "bg-menu_active"
                                  : ""
                                }`}
                            >
                              <span
                                className={`inline-block float-left mr-3 ${window.location.pathname === "/forms/kop"
                                    ? "kopActiveImg"
                                    : "kopImg"
                                  }`}
                              ></span>
                              <span
                                className={`inline-block text-sm ${window.location.pathname === "/forms/kop"
                                    ? "text-menuHvrColor font-semibold"
                                    : ""
                                  }`}
                              >
                                CREATE KOP MAR
                              </span>
                            </Link>
                          </li>
                          <li className="inline-block relative w-full">
                            <Link
                              to="/forms/rmf"
                              className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full hover:text-menuHvrColor rmfLi ${window.location.pathname === "/forms/rmf"
                                  ? "bg-menu_active"
                                  : ""
                                }`}
                            >
                              <span
                                className={`inline-block float-left mr-3 ${window.location.pathname === "/forms/rmf"
                                    ? "rmfActiveImg"
                                    : "rmfImg"
                                  }`}
                              ></span>
                              <span
                                className={`inline-block text-sm ${window.location.pathname === "/forms/rmf"
                                    ? "text-menuHvrColor font-semibold"
                                    : ""
                                  }`}
                              >
                                CREATE RELEASE MEDICATION RECEIPT
                              </span>
                            </Link>
                          </li>
                        </>
                      ) : (
                        ""
                      )}
                    </ul>
                  </li>
                ) : (
                  ""
                )}

                {/* {user.userRole === "FACILITY_USER" ||
                user.userRole === "FACILITY_ADMIN" ||
                user?.department === "ORDER_ENTRY" ? (
                  <li className="inline-block relative leading-8 hidden mr-4">
                    <button
                      className={`block py-3 px-8 rounded-lg rounded-b-none cursor-pointer hover:bg-bodybgrnd customMargin appmenuLi hover:text-menuHvrColor ${
                        window.location.pathname === "/documents"
                          ? "bg-bodybgrnd menuHvrBorder"
                          : ""
                      }`}
                    >
                      <span
                        className={`inline-block float-left mr-3 mt-1 w-6 h-8 ${
                          window.location.pathname === "/documents"
                            ? "documentsActiveImg"
                            : "documentsImg"
                        }`}
                      ></span>
                      <span
                        className={`inline-block text-sm ${
                          window.location.pathname === "/documents"
                            ? "text-menuHvrColor font-semibold"
                            : ""
                        }`}
                      >
                        DOCUMENTS
                      </span>
                    </button>
                    <ul className="submenu bg-bodybgrnd absolute hidden z-50 text-white w-56 ">
                      <li className="inline-block relative w-full">
                        <Link
                          to="/documents"
                          className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full appmenuLi hover:text-menuHvrColor${
                            window.location.pathname === "/documents"
                              ? "bg-menu_active"
                              : ""
                          }`}
                        >
                          <span
                            className={`inline-block float-left mr-3 ${
                              window.location.pathname === "/documents"
                                ? "documentsActiveImg"
                                : "documentsImg"
                            }`}
                          ></span>
                          <span
                            className={`inline-block text-sm ${
                              window.location.pathname === "/documents"
                                ? "text-menuHvrColor font-semibold"
                                : "menuTxt"
                            }`}
                          >
                            DOCUMENTS
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </li>
                ) : (
                  ""
                )} */}
                 <li className="inline-block relative leading-8 float-right">
                  <Link
                    to="/help"
                    className="block py-3 px-4 customMargin cursor-pointer"
                  >
                    <img
                      src={helpIcon}
                      alt="Help"
                      style={{ height: "32px", width: "auto" }}
                    />
                  </Link>
                </li>

                {user.userRole === "FACILITY_USER" ||
                  user?.userRole === "DEPARTMENT_USER" ? null : (
                  <li className="inline-block relative leading-8 float-right">
                    <button
                      className={`block py-3 px-8 rounded-lg rounded-b-none cursor-pointer hover:bg-bodybgrnd adminmenuLi customMargin hover:text-menuHvrColor ${window.location.pathname === "/users"
                          ? "bg-bodybgrnd menuHvrBorder"
                          : ""
                        }`}
                    >
                      <span
                        className={`inline-block float-left mr-3  ${window.location.pathname === "/users"
                            ? "adminActiveImg"
                            : "adminImg"
                          }`}
                      ></span>
                      <span
                        className={`inline-block text-sm ${window.location.pathname === "/users"
                            ? "text-menuHvrColor font-semibold"
                            : ""
                          }`}
                      >
                        ADMIN
                        <span className="invisible md:visible">
                          ISTRATION
                        </span>{" "}
                      </span>
                    </button>

                    <ul className="submenu bg-bodybgrnd absolute hidden z-50 text-white w-full">
                      <li className="inline-block relative w-full">
                        <Link
                          to="/users"
                          className={`px-4 text-sm cursor-pointer hover:bg-white inline-flex py-4 w-full hover:text-menuHvrColor usersLi ${window.location.pathname === "/users"
                              ? "bg-menu_active"
                              : ""
                            }`}
                        >
                          <span
                            className={`inline-block float-left mr-3 ${window.location.pathname === "/users"
                                ? "usersActiveImg"
                                : "usersImg"
                              }`}
                          ></span>
                          <span
                            className={`inline-block text-sm ${window.location.pathname === "/users"
                                ? "text-menuHvrColor font-semibold"
                                : ""
                              }`}
                          >
                            USERS
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </li>
                )}
              </>}
            </ul>
          </div>
        </div>
      </div>

      <Modal open={open} onClose={onCloseModal} center>
        <div className="pt-10 px-8 pb-4 ">
          <h3
            className="text-lg leading-6 font-medium text-gray-900 text-center"
            id="modal-headline"
          >
            Are you sure you want to logout?
          </h3>
          <div className="flex justify-center">
            <button
              onClick={() => {
                clearState();
                dispatch(onLogout());
              }}
              type="button"
              className="mr-0.5 rounded font-medium h-10 text-white w-auto px-6 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Yes
            </button>

            <button
              onClick={() => {
                setOpen(false);
              }}
              type="button"
              className="rounded font-medium h-10 text-white w-auto px-4 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Cancel
            </button>
          </div>
          {/*
           */}
        </div>
      </Modal>
      <Modal open={edituserOpen} onClose={onCloseUserModal}>
        <form onSubmit={handleSubmit(facSubmit)}>
          <ul>
            <li className={`inline-block text-sm leading-8 w-full`}>
              <label>Facility</label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <select
                name="chngefacility"
                aria-label="Select facility"
                ref={register({
                  required: "You must select facility",
                })}
                defaultValue={userFac}
                className="border focus:outline-none h-10 rounded-md pl-2 text-sm font-normal w-full"
              >
                <option value="">Select Facility</option>
                {facilityList
                  ? facilityList.map((facility, i) => {
                    return (
                      <option key={i} value={facility.id}>
                        {facility.name}
                      </option>
                    );
                  })
                  : null}
              </select>
              {errors.chngefacility && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  {errors.chngefacility?.message}
                </p>
              )}
            </li>
            <li className="text-center">
              <button
                type="submit"
                className="text-white w-full sm:w-auto h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
              >
                SUBMIT
              </button>
            </li>
          </ul>
        </form>
      </Modal>
    </div>
  );
};
export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(CipHeader)
);